/**
 * Header Megamenu Web Component
 * Handles image highlighting functionality for megamenu items
 */
class HeaderMegamenu extends HTMLElement {
  constructor() {
    super();
    this.menuItems = [];
    this.megamenuImages = [];
    this.boundHighlightImage = this.highlightImage.bind(this);
    this.boundClearAllHighlights = this.clearAllHighlights.bind(this);
  }

  connectedCallback() {
    // Small delay to ensure child elements are rendered
    setTimeout(() => {
      this.setupEventListeners();
    }, 0);
  }

  disconnectedCallback() {
    this.cleanupEventListeners();
  }

  setupEventListeners() {
		this.mainImage = this.querySelector('.header-megamenu-main-image');
    // Find menu items and images within this component
    this.menuItems = this.querySelectorAll('.gen-sub-menu__item[data-image-id]');
    this.megamenuImages = this.querySelectorAll('.megamenu-image-item[data-image-id]');
    
    if (!this.menuItems.length || !this.megamenuImages.length) {
      console.log('HeaderMegamenu: No menu items or images found');
      return;
    }
    
    // Add hover event listeners to menu items
    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', this.boundHighlightImage);
      menuItem.addEventListener('mouseleave', this.boundClearAllHighlights);
    });

    // Remove active class when mouse leaves the megamenu area
    this.addEventListener('mouseleave', this.boundClearAllHighlights);
  }

  cleanupEventListeners() {
    // Remove event listeners to prevent memory leaks
    this.menuItems.forEach(menuItem => {
      menuItem.removeEventListener('mouseenter', this.boundHighlightImage);
      menuItem.removeEventListener('mouseleave', this.boundClearAllHighlights);
    });

    this.removeEventListener('mouseleave', this.boundClearAllHighlights);
  }

  highlightImage(event) {
    const menuItem = event.currentTarget;
    const imageId = menuItem.getAttribute('data-image-id');

    if (!imageId) return;

    // Remove active class from all images
    this.clearAllHighlights();

    // Add active class to matching image
    const targetImage = this.querySelector(`.megamenu-image-item[data-image-id="${imageId}"]`);
    if (targetImage) {
      targetImage.classList.add('active');

      // Optional: Add active class to the menu item as well
      menuItem.classList.add('active');

      // Hide the main image when hovering over menu items
      if (this.mainImage) {
        this.mainImage.classList.add('hidden');
      }
    }
  }

  clearAllHighlights() {
    // Remove active class from all images
    this.megamenuImages.forEach(img => {
      img.classList.remove('active');
    });

    // Remove active class from all menu items
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });

    // Show the main image when no menu items are being hovered
    if (this.mainImage) {
      this.mainImage.classList.remove('hidden');
    }
  }

  // Public method to programmatically highlight an image
  highlightImageById(imageId) {
    this.clearAllHighlights();
    const targetImage = this.querySelector(`.megamenu-image-item[data-image-id="${imageId}"]`);
    if (targetImage) {
      targetImage.classList.add('active');
			this.mainImage.classList.add('hidden');
    }
  }

  // Public method to get current active image
  getActiveImage() {
    return this.querySelector('.megamenu-image-item.active');
  }

  // Public method to get all menu items
  getMenuItems() {
    return Array.from(this.menuItems);
  }

  // Public method to get all images
  getImages() {
    return Array.from(this.megamenuImages);
  }
}

// Register the web component
customElements.define('header-megamenu', HeaderMegamenu);

// Export for potential use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = HeaderMegamenu;
} 

/**
 * Grandchild Menu Toggle Function
 * Handles clicking on js-button-toggle-menu-grandchild to toggle active class on drawer-menu-grandchild-list
 */
function initGrandchildMenuToggles() {
  // Find all grandchild menu toggle buttons
  const grandchildToggleButtons = document.querySelectorAll('.js-button-toggle-menu-grandchild');
  
  // Add click event listeners to each toggle button
  grandchildToggleButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const grandchildList = this.nextElementSibling;
      
      // Check if the next sibling is the grandchild list
      if (grandchildList && grandchildList.classList.contains('drawer-menu-grandchild-list')) {
        // Toggle the active class
        grandchildList.classList.toggle('hidden');
        
        // Optional: Add visual feedback to the button
        this.classList.toggle('active');
      }
    });
  });
}

// Initialize grandchild menu toggles when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGrandchildMenuToggles);
} else {
  initGrandchildMenuToggles();
} 


